﻿$.fn.dxCtrlWizardItem3ResaCoordonnees = function custom_dxCtrlWizardItem3ResaCoordonnees(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizarditem3resacoordonnees dx-ctrl");
        this.createInstance(new cdxCtrlWizardItem3ResaCoordonnees(this, option));
    }
    return this;
}

window.cdxCtrlWizardItem3ResaCoordonnees = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivDetail = null
    var dxAdrEmail = null
    function mConstruit() {
        container.empty()

        container.css("padding", "20px")

        $("<div style='text-align:center;font-weight:bold;font-size:140%;'>Saisissez vos coordonnées</div>").appendTo(container)

        $("<div style='padding-top:20px;'>Veuillez saisir votre adresse email:</div>").appendTo(container)

        dxAdrEmail = $("<div style='margin:0 10px 30px 10px;'/>").appendTo(container).dxCtrlTextEmail({
            label: "Adresse email *",
            labelMode: "floating",
            value: (option.dataForResa.clDataSaisie ? (option.dataForResa.clDataSaisie.data.adresse_email ? option.dataForResa.clDataSaisie.data.adresse_email : "") : ""),
            onValueChanged: function (e) {
                dxAdrEmail.element().css("background-color", "")
                option.dataForResa.clDataSaisie = new cDataSaisie({ bddCtrl: option.bddCtrl })
                if (!dxAdrEmail.hasErreur && ((e.value == null) ? "" : e.value).length > 0) {
                    option.dataForResa.clDataSaisie.mInitWithAdresseEmail(e.value, function () {
                        //option.onCreateDataSaisie(option.dataForResa.clDataSaisie)
                        mRempliDetail()
                        $DivDetail.slideDown(300)
                    })
                } else {
                    //option.onCreateDataSaisie(option.dataForResa.clDataSaisie)
                    mRempliDetail()
                    $DivDetail.slideUp(300)
                }
            },
            onContentReady: function (e) {
                e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlTextEmail("instance")

        $DivDetail = $("<div style='display:none'/>").appendTo(container)
        mRempliDetail()
        if (option.dataForResa.clDataSaisie.data.adresse_email && option.dataForResa.clDataSaisie.data.adresse_email.length > 0) {
            $DivDetail.slideDown(300)
        }

        var $Table = $("<table style='width:calc(100% - 40px);margin:20px 20px 0 20px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var $AAddHeberg = $("<a href='javascript:void(0)'>← Votre panier</a>").appendTo($Td)
        $AAddHeberg.on("click", function (e) {
            option.onPrevious()
        })
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var $AAddHeberg = $("<a href='javascript:void(0)'>Votre règlement →</a>").appendTo($Td)
        $AAddHeberg.on("click", function (e) {
            option.onNext()
        })
    }

    var dxCtrlDetail = null
    function mRempliDetail() {
        $DivDetail.empty()
        dxCtrlDetail = $("<div/>").appendTo($DivDetail).dxCtrlDataSaisieModif({
            bddCtrl: option.bddCtrl,
            dataSaisie: option.dataForResa.clDataSaisie.data,
            onDemandeLstObligatoire: function (idTypeClient) {
                return option.bddCtrl.paraAppli.mGetPara("hebergement_internet_champ_saisie_client_obligatoire")
            },
            //lstObligatoire: option.bddCtrl.paraAppli.mGetPara("hebergement_internet_champ_saisie_client_obligatoire"),
            isExterne: true,
            showTel: true,
            onValueChanged: function () {
            }
        }).dxCtrlDataSaisieModif("instance")
    }
    function mIsSaisieCoordonneeComplete() {
        complete = true
        var clDataSaisie = option.dataForResa.clDataSaisie
        option.bddCtrl.paraAppli.mGetPara("hebergement_internet_champ_saisie_client_obligatoire").forEach(function (item) {
            switch (item) {
                case "nom":
                    if (!clDataSaisie.data.con_nom || clDataSaisie.data.con_nom.length == 0) complete = false
                    break;
                case "prenom":
                    if (!clDataSaisie.data.con_prenom || clDataSaisie.data.con_prenom.length == 0) complete = false
                    break;
                case "adr":
                    if (!clDataSaisie.data.adr_ad1 || clDataSaisie.data.adr_ad1.length == 0) complete = false
                    break;
                case "cp":
                    if (!clDataSaisie.data.adr_cp || clDataSaisie.data.adr_cp.length == 0) complete = false
                    break;
                case "ville":
                    if (!clDataSaisie.data.adr_ville || clDataSaisie.data.adr_ville.length == 0) complete = false
                    break;
                case "pays":
                    if (!dclDataSaisie.data.adr_pays || clDataSaisie.data.adr_pays.length == 0) complete = false
                    break;
                case "tel":
                    if (!clDataSaisie.data.tel_sms || clDataSaisie.data.tel_sms.length == 0) complete = false
                    break;
            }
        })
        return complete
    }


    this.mColorObligatoire = function () {
        var lstOblig = []
        if (!dxAdrEmail.option("value") || dxAdrEmail.hasErreur) {
            dxAdrEmail.element().css("background-color", "#ffcccc")
            lstOblig.push(dxAdrEmail)
        }
        lstOblig = lstOblig.concat(dxCtrlDetail.mColorObligatoire())
        return lstOblig
    }

    this.isOkForNext = function (dxScroll) {
        var okForNext = true
        var firstElementScroll = null
        var firstCtrlFocus = null

        if (!mIsSaisieCoordonneeComplete()) {
            var lstCtrl = this.mColorObligatoire()
            lstCtrl.forEach(function (dx) {
                dx.element().css("border-left", "3px solid red")
                dx.element().addClass("jiggle").css("animation-duration", "0.12s");
                window.setTimeout(function () { dx.element().removeClass("jiggle").css("animation-duration", ""); }, 500)
                if (!firstElementScroll) firstElementScroll = dx.element()
                if (!firstCtrlFocus) firstCtrlFocus = dx.element()
            })
            okForNext=false
        }

        if (dxScroll && firstElementScroll) {
            window.setTimeout(function () {
                dxScroll.smoothScrollToElement(firstElementScroll, 600, function () {
                    if (firstCtrlFocus && firstCtrlFocus.focus) firstCtrlFocus.focus()
                })
            }, 10)
        }
        if (!okForNext) mNotify("Veuillez saisir l'ensemble des coordonnées", "warning", 6000)

        return okForNext
    }

    this.mGetClassIconeForLstItem = function () {
        return "fas fa-map"
    }
    this.hasHeight100Percent = function () { return true }
    this.title = function () { return "Vos coordonnées" }
    this.mGetProprieteImage = function () {
        var urlFond = ""
        var lstImage = JSON.parse(option.bddCtrl.paraAppli.mGetPara("hebergement_resa_internet_list_image_arriere_plan"))
        if (lstImage.length > 0) {
            var idxImage = Math.floor(Math.random() * lstImage.length)
            var urlFond = lstImage[idxImage]
        } else {
            var idxImage = Math.floor(Math.random() * 20) + 1;
            var urlFond = parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + idxImage + ".jpg"
        }
        return {
            url: urlFond,
            position: (parametre.isPhone ? "Gauche" : "Droite")
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        return parametre.url_appli.replace("app.", "appgo.") + "/" + option.bddCtrl.nom_base + "/" +
            "2/reservation"
    }

    this.mGetIndexFromUrlLink = function (locationPathname) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        //locationPathname=/nom_base/id_page/reservation
        return locationPathname.split("/")[2]
    }


    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}